import { atom } from "recoil";

export const sidebarDisp_ = atom({
    key: "sidebar",
    default: "none"
});
